export default __webpack_public_path__ + "static/media/Parallax-HUD-01.141495a1.jpg";